export default {
      id: "logo-instagram-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#logo-instagram",
      toString: function () {
        return this.url;
      }
    }